<template>
  <v-container>
    <v-row>
      <v-col cols="4" offset="4">
        <v-card color="primary" class="card">
          <v-card-title class="justify-center font-weight-bold">Movimientos realizados</v-card-title>
          <v-card-text>
            <v-list color="primary">
              <v-list-item v-for="movimiento in movimientos" :key="movimiento.idMovimiento">
                <v-list-item-content>
                  <v-list-item-subtitle>{{ movimiento.CatTipoMovimiento.title }}</v-list-item-subtitle>
                  <v-list-item-title>{{ movimiento.fecha }}</v-list-item-title>
                  <v-list-item-subtitle>{{ movimiento.observaciones }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-avatar color="secondary">
                    <div class="text-overline white--text">{{ movimiento.cantidad }}</div>
                  </v-avatar>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <v-container>
              <v-row>
                <v-col cols="12" align="center">
                  <div class="text-h6">Cantidad total en inventario: {{ getStock() }}</div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn text class="error--text mb-4 mx-8" v-on:click="$router.go(-1)">Salir</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  async mounted() {
    this.fetchMovimientoEquipamientoByItem(this.id)
  },

  props: {
    id: {
      type: Number,
    },
  },

  data() {
    return {}
  },

  computed: {
    ...mapGetters('movimientoEquipamiento', {
      movimientos: 'getMovimientoEquipamiento',
    }),
  },

  methods: {
    ...mapActions('movimientoEquipamiento', ['fetchMovimientoEquipamientoByItem']),

    getStock: function () {
      var stock = 0

      this.movimientos.forEach((movimiento) => {
        stock = stock + movimiento.cantidad
      })

      return stock
    },
  },
}
</script>

<style scoped>
/* Estilos modernos para Movimientos de Equipamiento */
.card {
  background: rgba(46, 36, 22, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 159, 67, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  animation: fadeInUp 0.6s ease-out;
}

/* Títulos */
::v-deep .v-card-title {
  color: #e0e0e0 !important;
  font-weight: 700 !important;
  letter-spacing: 0.5px;
  padding: 24px !important;
}

.text-h6 {
  color: #ffbe76 !important;
  font-weight: 700;
}

/* Listas */
::v-deep .v-list {
  background: transparent !important;
}

::v-deep .v-list-item {
  border-radius: 12px;
  margin: 4px 0;
  background: rgba(46, 36, 22, 0.4);
  border: 1px solid rgba(255, 159, 67, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
}

::v-deep .v-list-item:hover {
  background: rgba(255, 159, 67, 0.15);
  border-color: rgba(255, 159, 67, 0.3);
  transform: translateX(8px);
  box-shadow: 0 4px 12px rgba(255, 159, 67, 0.2);
}

::v-deep .v-list-item-title {
  color: #e0e0e0 !important;
  font-weight: 600;
}

::v-deep .v-list-item-subtitle {
  color: rgba(224, 224, 224, 0.7) !important;
}

/* Avatares */
::v-deep .v-avatar {
  background: rgba(255, 159, 67, 0.15) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 159, 67, 0.3);
  transition: all 0.3s ease;
}

::v-deep .v-list-item:hover .v-avatar {
  transform: scale(1.1);
  border-color: #ff9f43;
  box-shadow: 0 8px 24px rgba(255, 159, 67, 0.4);
}

::v-deep .v-avatar .text-overline {
  color: #ffffff !important;
  font-weight: 700;
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 159, 67, 0.3);
}

::v-deep .v-btn.error--text:hover {
  background: rgba(255, 82, 82, 0.1) !important;
}

/* Card actions */
::v-deep .v-card-actions {
  padding: 24px !important;
  background: rgba(255, 159, 67, 0.05);
  border-top: 1px solid rgba(255, 159, 67, 0.1);
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 159, 67, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 159, 67, 0.6);
}

/* Animación */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
